import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { ClaimService } from '../services/claim/claim.service';
import { FeatureFlagService } from '../services/feature-flag/feature-flag.service';
import { forLifeOf, LifecycleAware } from '../utilities/rxjs.helpers';

// TODO(dmayer): Support an array of featureFlags, same as FeatureFlagDirective.
@LifecycleAware()
@Directive({
    selector: '[claimAndFeatureFlag]'
})
export class ClaimAndFeatureFlagDirective implements OnInit, OnDestroy {
    private _hasClaim?: boolean;
    private _hasFeatureFlag?: boolean;
    private _hasEmbeddedView = false;
    private _claimSubscription: Subscription;
    private _featureFlagSubscription: Subscription;
    private _claim: number;
    private _featureFlag: string;

    constructor(
        public claimService: ClaimService,
        public featureFlagService: FeatureFlagService,
        private _templateRef: TemplateRef<any>,
        private _viewContainerRef: ViewContainerRef
    ) {}

    @Input() public set claimAndFeatureFlag(config: { claim: number; featureFlag: string }) {
        if (this._claimSubscription) {
            this._claimSubscription.unsubscribe();
        }
        if (this._featureFlagSubscription) {
            this._featureFlagSubscription.unsubscribe();
        }

        if (config.claim) {
            this._claim = config.claim;
            this._claimSubscription = this.claimService
                .isOn(config.claim)
                .pipe(forLifeOf(this))
                .subscribe((claimIsOn) => {
                    this._hasClaim = claimIsOn;
                    this._process();
                });
        }

        if (config.featureFlag) {
            this._featureFlag = config.featureFlag;
            this._featureFlagSubscription = this.featureFlagService
                .isOn(config.featureFlag)
                .pipe(forLifeOf(this))
                .subscribe((featureFlagIsOn) => {
                    this._hasFeatureFlag = featureFlagIsOn;
                    this._process();
                });
        }
    }

    public ngOnInit(): void {
        if (!this._hasEmbeddedView && !this._claim && !this._featureFlag) {
            this._viewContainerRef.createEmbeddedView(this._templateRef);
            this._hasEmbeddedView = true;
        }
    }

    public ngOnDestroy(): void {}

    private _process(): void {
        if (this._hasClaim === true && this._hasFeatureFlag === true) {
            if (!this._hasEmbeddedView) {
                this._viewContainerRef.createEmbeddedView(this._templateRef);
                this._hasEmbeddedView = true;
            }
        } else if (this._hasClaim === false || this._hasFeatureFlag === false) {
            this._viewContainerRef.clear();
            this._hasEmbeddedView = false;
        }
    }
}
